// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"91cfe006","210":"31246e46","523":"1cc7bdab"}[chunkId] + ".chunk.css";
};